import { render } from "./CallLeads.vue?vue&type=template&id=dc79f660&ts=true"
import script from "./CallLeads.vue?vue&type=script&lang=ts"
export * from "./CallLeads.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__